import React, { useEffect, useState } from "react";
import { Accordion, Modal } from "react-bootstrap";
import "./TermInsuranceStepform.css";
import OccupationType from "./OccupationType/OccupationType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import Annual_Income from "./Annual_Income/Annual_Income";
import Qualification from "./Qualification/Qualification";
import SmokeOrTobacco from "./SmokeOrTobacco/SmokeOrTobacco";
import SelectCurrentCity from "./SelectCurrentCity/SelectCurrentCity";

const TermInsuranceStepform = (props) => {
  const [current, setCurrent] = useState(1);

  const handleNext = () => {
    setCurrent((prev) => Math.min(prev + 1, stepLabels.length));
  };

  const handlePrevious = () => {
    setCurrent((prev) => Math.max(prev - 1, 1));
  };

  const isStepCompleted = (stepNumber) => {
    return stepNumber <= current;
  };

  const stepLabels = [
    { id: 1, label: "Please choose your occupation type" },
    { id: 2, label: "Seller Information" },
    { id: 3, label: "Address" },
    { id: 4, label: "Address" },
    { id: 5, label: "Address" },
  ];

  const [occupation, setOccupation] = useState("Salaried");
  const [income, setIncome] = useState(200000);
  const [qualification, setQualification] = useState("12th Pass");
  const [smoke, setSmoke] = useState(0);
  const [city, setCity] = useState();
  useEffect(() => {
    if(props.data){
      setOccupation(props?.data?.occupation);
      setIncome(props?.data?.income);
      setQualification(props?.data?.qualification);
      setSmoke(props?.data?.smoke_status);
  
      setCity({ label: props?.data?.city, value: props?.data?.city });
    }
   
  }, [props.data]);

  return (
    <section>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="TermInsuranceStepform modal-holder"
      >
        <Modal.Body>
          <div className="term_insurance_main_div">
            <p
              className="back_text"
              onClick={() => {
                handlePrevious();
              }}
            >
              <FontAwesomeIcon icon={faAngleLeft} /> Back
            </p>

            <div className="form_holder">
              <div className="progress_bar_container">
                <div className="step_row">
                  <p className="title">You are almost there!</p>
                  <p className="subtxet">
                    Till we gather information, let us know you more a bit
                  </p>

                  <div className="step_row_holder">
                    {stepLabels.map((item, index) => (
                      <div className="step_center" key={item.id}>
                        <div
                          className={`step ${
                            isStepCompleted(index + 1) ? "completed" : ""
                          }`}
                        ></div>
                      </div>
                    ))}
                  </div>

                  <p className="step_no">
                    <span className="current_step">{current}</span>
                    {`/${stepLabels?.length}`}
                  </p>
                </div>
              </div>
            </div>

            <div className="componbent_holder">
              {current === 1 && (
                <OccupationType
                  data={props.data}
                  handleNext={handleNext}
                  occupation={occupation}
                  setOccupation={setOccupation}
                />
              )}

              {current === 2 && (
                <Annual_Income
                  income={income}
                  setIncome={setIncome}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                />
              )}

              {current === 3 && (
                <Qualification
                  setQualification={setQualification}
                  qualification={qualification}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                />
              )}

              {current === 4 && (
                <SmokeOrTobacco
                  smoke={smoke}
                  setSmoke={setSmoke}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                />
              )}

              {current === 5 && (
                <SelectCurrentCity
                  occupation={occupation}
                  income={income}
                  qualification={qualification}
                  smoke={smoke}
                  alldata={props.data}
                  setCity={setCity}
                  city={city}
                  handleNext={handleNext}
                  handlePrevious={handlePrevious}
                  closeParentModal={props?.onHide}
                  setSuccessShowModalNew={props?.setSuccessShowModalNew}
                />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default TermInsuranceStepform;
